import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast , ToastContainer } from 'react-toastify';
import BrandController from './controllers/brand-controller';
import VariantController from './controllers/variant-controller';
import TVAController from './controllers/tva-controller';
import EditProductVariantModal from './components/EditProductVariantModal';
import { deleteVariant, updateProduct, deleteVariantImage, addProductVariantImage, addProductVariants } from './controllers/products-controller';
import 'react-toastify/dist/ReactToastify.css';
import './styles/style.css';
import SupplierController from './controllers/supplier-controller';

import ProductHeader from './edit-product-components/ProductHeader';
import ErrorBanner from './edit-product-components/ErrorBanner';
import ProductInfoSection from './edit-product-components/ProductInfoSection';
import PricingSection from './edit-product-components/PricingSection';
import SupplierDropdown from './edit-product-components/SupplierDropdown';
import BrandDropdown from './edit-product-components/BrandDropdown';
import TVADropdown from './edit-product-components/TVADropdown';
import ProductImagesSection from './edit-product-components/ProductImagesSection';
import VariantToggleSection from './edit-product-components/VariantToggleSection';
import VariantConfigurationSection from './edit-product-components/VariantConfigurationSection';
import FormActionsFooter from './edit-product-components/FormActionsFooter';
import LoadingIndicator from './edit-product-components/LoadingIndicator';
import ConfirmationModals from './edit-product-components/ConfirmationModals';
import CreationModals from './edit-product-components/CreationModals';
import PackProductSection from './new-product-components/PackProductSection';

const BASEURL = process.env.REACT_APP_API_URL;

const EditProductPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [productName, setProductName] = useState('');
  const [productDesc, setProductDesc] = useState('');
  const [reference, setReference] = useState('');
  const [barcode, setBarcode] = useState('');
  const [price, setPrice] = useState('');
  const [prixAchatHT, setPrixAchatHT] = useState('');
  const [prixAchatTTC, setPrixAchatTTC] = useState('');
  const [prixVenteHT, setPrixVenteHT] = useState('');
  const [enPromo, setEnPromo] = useState(false);
  const [prixVentePromo, setPrixVentePromo] = useState('');
  const [livraisonGratuit, setLivraisonGratuit] = useState(false);
  const [livraisonGratuitQuantite, setLivraisonGratuitQuantite] = useState('');
  const [stockRequis, setStockRequis] = useState(true);
  const [supplierId, setSupplierId] = useState('');
  const [brandId, setBrandId] = useState('');
  const [tvaId, setTvaId] = useState('');
  const [supplierSearchTerm, setSupplierSearchTerm] = useState('');
  const [brandSearchTerm, setBrandSearchTerm] = useState('');
  const [isSupplierDropdownOpen, setIsSupplierDropdownOpen] = useState(false);
  const [isBrandDropdownOpen, setIsBrandDropdownOpen] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [isLoadingSuppliers, setIsLoadingSuppliers] = useState(false);
  const [supplierError, setSupplierError] = useState(null);
  const [brands, setBrands] = useState([]);
  const [isLoadingBrands, setIsLoadingBrands] = useState(false);
  const [brandError, setBrandError] = useState(null);
  const [isTvaDropdownOpen, setIsTvaDropdownOpen] = useState(false);
  const [tvaSearchTerm, setTvaSearchTerm] = useState('');
  const [productImages, setProductImages] = useState([]);
  const [productImagePreviews, setProductImagePreviews] = useState([]);
  const supplierDropdownRef = useRef(null);
  const brandDropdownRef = useRef(null);
  const [pathForDelete, setPathForDelete] = useState([]);
  const [isCreateSupplierModalOpen, setIsCreateSupplierModalOpen] = useState(false);
  const [newSupplierName, setNewSupplierName] = useState('');
  const [isSubmittingSupplier, setIsSubmittingSupplier] = useState(false);
  const [newSupplierEmail, setNewSupplierEmail] = useState('');
  const [newSupplierTel, setNewSupplierTel] = useState('');
  const [newSupplierAddress, setNewSupplierAddress] = useState('');
  const [newSupplierFiscal, setNewSupplierFiscal] = useState('');

  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const filteredSuppliers = suppliers.filter(supplier =>
    supplier.name.toLowerCase().includes(supplierSearchTerm.toLowerCase())
  );

  const filteredBrands = brands.filter(brand =>
    brand.name.toLowerCase().includes(brandSearchTerm.toLowerCase())
  );
  const selectedSupplier = suppliers.find(s => s.id === supplierId);
  const selectedBrand = brands.find(b => b.id === brandId);
  const [enableVariants, setEnableVariants] = useState(false);
  const [selectedVariants, setSelectedVariants] = useState([]);
  const [generatedVariants, setGeneratedVariants] = useState([]);
  const [showGeneratedVariants, setShowGeneratedVariants] = useState(false);
  const [isVariantModalOpen, setIsVariantModalOpen] = useState(false);
  const [variantAttributes, setVariantAttributes] = useState([]);
  const [isLoadingVariants, setIsLoadingVariants] = useState(false);
  const [variantError, setVariantError] = useState(null);
  const [tvaRates, setTvaRates] = useState([]);
  const [isLoadingTva, setIsLoadingTva] = useState(false);
  const [tvaError, setTvaError] = useState(null);
  const filteredTvaRates = tvaRates.filter(tva =>
    tva.taux.toString().includes(tvaSearchTerm)
  );
  const selectedTva = tvaRates.find(t => t.id === tvaId);
  const [deleteImageModalOpen, setDeleteImageModalOpen] = useState(false);
  const [imageToDelete, setImageToDelete] = useState(null);
  const [deleteImageLoading, setDeleteImageLoading] = useState(false);
  const [deleteVariantModalOpen, setDeleteVariantModalOpen] = useState(false);
  const [variantToDelete, setVariantToDelete] = useState(null);
  const [deleteVariantLoading, setDeleteVariantLoading] = useState(false);
  const [imageUploadLoading, setImageUploadLoading] = useState({});
  const [isCreateBrandModalOpen, setIsCreateBrandModalOpen] = useState(false);
  const [newBrandName, setNewBrandName] = useState('');
  const [isSubmittingBrand, setIsSubmittingBrand] = useState(false);
  const [packProducts, setPackProducts] = useState([]);
  const tvaDropdownRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (isSupplierDropdownOpen &&
        supplierDropdownRef.current &&
        !supplierDropdownRef.current.contains(event.target) &&
        !event.target.closest('.fixed.z-50')) {
        setIsSupplierDropdownOpen(false);
      }
      if (isBrandDropdownOpen &&
        brandDropdownRef.current &&
        !brandDropdownRef.current.contains(event.target) &&
        !event.target.closest('.fixed.z-50')) {
        setIsBrandDropdownOpen(false);
      }
      if (isTvaDropdownOpen &&
        tvaDropdownRef.current &&
        !tvaDropdownRef.current.contains(event.target) &&
        !event.target.closest('.fixed.z-50')) {
        setIsTvaDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isSupplierDropdownOpen, isBrandDropdownOpen, isTvaDropdownOpen]);



  const toggleVariantValue = (attributeId, valueId) => {
    const variantKey = JSON.stringify({ attributeId, valueId });
    setSelectedVariants(prev => {
      const exists = prev.some(item =>
        JSON.stringify({ attributeId: item.attributeId, valueId: item.valueId }) === variantKey
      );
      if (exists) {
        return prev.filter(item =>
          JSON.stringify({ attributeId: item.attributeId, valueId: item.valueId }) !== variantKey
        );
      } else {
        return [...prev, { attributeId, valueId }];
      }
    });
  };

  useEffect(() => {
    const fetchSuppliersList = async () => {
      try {
        setIsLoadingSuppliers(true);
        setSupplierError(null);
        const response = await SupplierController.fetchAllSuppliers();
        if (response) {
          setSuppliers(response);
        } else {
          setSuppliers([]);
        }
      } catch (error) {
        console.error('Error fetching suppliers:', error);
        setSupplierError('Impossible de charger la liste des fournisseurs');
      } finally {
        setIsLoadingSuppliers(false);
      }
    };
    fetchSuppliersList();
  }, []);

  useEffect(() => {
    const fetchBrandsList = async () => {
      try {
        setIsLoadingBrands(true);
        setBrandError(null);
        const data = await BrandController.fetchAllBrands();
        if (data) {
          setBrands(data);
        } else {
          setBrands([]);
        }
      } catch (error) {
        console.error('Error fetching brands:', error);
        setBrandError('Impossible de charger la liste des marques');
      } finally {
        setIsLoadingBrands(false);
      }
    };
    fetchBrandsList();
  }, []);

  useEffect(() => {
    const fetchVariantsList = async () => {
      try {
        setIsLoadingVariants(true);
        setVariantError(null);
        const response = await VariantController.fetchAllVariants();
        if (response) {
          setVariantAttributes(response);
        } else {
          setVariantAttributes([]);
        }
      } catch (error) {
        console.error('Error fetching variants:', error);
        setVariantError('Impossible de charger la liste des attributs de variante');
      } finally {
        setIsLoadingVariants(false);
      }
    };
    fetchVariantsList();
  }, []);

  useEffect(() => {
    const fetchTvaRates = async () => {
      try {
        setIsLoadingTva(true);
        setTvaError(null);
        const data = await TVAController.fetchAllTva();
        if (data) {
          setTvaRates(data);
        } else {
          setTvaRates([]);
        }
      } catch (error) {
        console.error('Error fetching TVA rates:', error);
        setTvaError('Impossible de charger les taux de TVA');
      } finally {
        setIsLoadingTva(false);
      }
    };
    fetchTvaRates();
  }, []);

  useEffect(() => {
    const fetchProductData = async () => {
      if (!id) {
        setError("ID du produit non spécifié");
        setIsLoading(false);
        return;
      }
      try {
        setIsLoading(true);
        setError(null);
        const response = await fetch(`${BASEURL}/Product/byId/${id}`);
        if (!response.ok) {
          throw new Error(`Erreur lors de la récupération du produit: ${response.status}`);
        }
        const productData = await response.json();
        setProductName(productData.name || '');
        setProductDesc(productData.description || '');
        setReference(productData.reference || '');
        setBarcode(productData.codeABarre || '');
        setPrice(productData.prixVenteTTC || '');
        setPrixAchatTTC(productData.prixAchatTTC || '');
        setSupplierId(productData.fournisseurId?.toString() || '');
        setBrandId(productData.marqueId?.toString() || '');
        setTvaId(productData.tvaId?.toString() || '');
        // Populate promo fields if present (handle different API shapes)
        try {
          const promoFlag = (
            productData.enPromo === true ||
            productData.enPromo === 1 ||
            productData.EnPromo === true ||
            productData.EnPromo === 'true' ||
            productData.EnPromo === 1
          );
          setEnPromo(Boolean(promoFlag));
        } catch (e) {
          setEnPromo(false);
        }
        setPrixVentePromo(productData.prixVentePromo ?? productData.PrixVentePromo ?? '');
        // Populate free delivery fields
        try {
          const livraisonFlag = (
            productData.livraisonGratuit === true ||
            productData.livraisonGratuit === 1 ||
            productData.LivraisonGratuit === true ||
            productData.LivraisonGratuit === 'true' ||
            productData.LivraisonGratuit === 1
          );
          setLivraisonGratuit(Boolean(livraisonFlag));
        } catch (e) {
          setLivraisonGratuit(false);
        }
        setLivraisonGratuitQuantite(
          (productData.livraisonGratuitQuantite ?? productData.LivraisonGratuitQuantite ?? '') === 0
            ? ''
            : (productData.livraisonGratuitQuantite ?? productData.LivraisonGratuitQuantite ?? '')
        );
        // Stock is required unless explicitly turned off
        setStockRequis((productData.stockRequis ?? productData.StockRequis) !== false);
        // Load pack products
        if (productData.packProducts && productData.packProducts.length > 0) {
          setPackProducts(productData.packProducts.map(p => ({
            qte: p.qte.toString(),
            prixUnitaireTTC: p.prixUnitaireTTC.toString()
          })));
        }
        if (productData.imageUrl && productData.imageUrl.length > 0) {
          const imagePreviews = productData.imageUrl.map(url => ({
            url,
            isFromServer: true
          }));
          setProductImagePreviews(imagePreviews);
        }
        if (productData.isVariant && productData.productVariants && productData.productVariants.length > 0) {
          setEnableVariants(true);
          setShowGeneratedVariants(true);
          const formattedVariants = productData.productVariants.map(variant => {
            return {
              id: variant.id,
              combination: variant.name,
              sku: variant.reference,
              stock: variant.stock || 0,
              originalStock: variant.stock || 0,
              imageUrl: variant.imageUrl || [],
              serverData: true,
              variantValues: variant.variantValue || [],
              barCode : variant.codeABarre || '',
              options: []
            };
          });
          setGeneratedVariants(formattedVariants);
        }
      } catch (error) {
        console.error("Failed to fetch product:", error);
        setError(`Erreur lors du chargement du produit: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    };
    fetchProductData();
  }, [id]);

  useEffect(() => {
    if (generatedVariants.length > 0 && generatedVariants[0].serverData && variantAttributes.length > 0) {
      const alreadyProcessed = generatedVariants.every(variant =>
        Array.isArray(variant.options) && variant.options.length > 0);
      if (alreadyProcessed) return;
      const variantValueMap = {};
      variantAttributes.forEach(attr => {
        attr.values.forEach(value => {
          variantValueMap[value.id] = {
            attributeId: attr.id,
            valueId: value.id,
            attributeName: attr.name,
            valueName: value.value
          };
        });
      });
      const updatedVariants = generatedVariants.map(variant => {
        const options = [];
        variant.variantValues?.forEach(vv => {
          const valueInfo = variantValueMap[vv.variantValueId];
          if (valueInfo) {
            options.push({
              attributeId: valueInfo.attributeId,
              attributeName: valueInfo.attributeName,
              valueId: valueInfo.valueId,
              value: valueInfo.valueName
            });
          }
        });
        return {
          ...variant,
          options
        };
      });
      const hasChanges = JSON.stringify(updatedVariants) !== JSON.stringify(generatedVariants);
      if (hasChanges) {
        setGeneratedVariants(updatedVariants);
        const selectedVals = new Set();
        updatedVariants.forEach(variant => {
          variant.options.forEach(option => {
            selectedVals.add(JSON.stringify({
              attributeId: option.attributeId,
              valueId: option.valueId
            }));
          });
        });
        setSelectedVariants(Array.from(selectedVals).map(val => JSON.parse(val)));
      }
    }
  }, [generatedVariants, variantAttributes]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!productName || !price || !reference ||
      !prixAchatTTC || !tvaId) {
      setError('Veuillez remplir tous les champs obligatoires');
      return;
    }
    try {
      setIsSubmitting(true);
      const formatDecimal = (value) => {
        return parseFloat(value).toString().replace('.', ',');
      };
      const formData = new FormData();
      const remainingServerImages = productImagePreviews
        .filter(img => img.isFromServer)
        .map(img => img.url);
      formData.append('id', id);
      formData.append('description', productDesc || "");
      formData.append('name', productName);
      formData.append('codeABarre', barcode);
      formData.append('prixVenteHt', formatDecimal(prixVenteHT));
      formData.append('prixVenteTTC', formatDecimal(price));
      formData.append('prixAchatTTC', formatDecimal(prixAchatTTC));
      formData.append('prixAchatHT', formatDecimal(prixAchatHT));
      // Promotion fields
      formData.append('enPromo', enPromo ? 'true' : 'false');
      formData.append('prixVentePromo', enPromo && prixVentePromo ? formatDecimal(prixVentePromo) : '0');
      formData.append('livraisonGratuit', livraisonGratuit ? 'true' : 'false');
      formData.append('livraisonGratuitQuantite', livraisonGratuit && livraisonGratuitQuantite ? parseInt(livraisonGratuitQuantite, 10) : '0');
      formData.append('stockRequis', stockRequis ? 'true' : 'false');
      formData.append('tvaId', parseInt(tvaId));
      formData.append('stock', 0);
      formData.append('reference', reference);
      formData.append('isVariant', enableVariants && generatedVariants.length > 0);
      if (brandId) {
        formData.append('marqueId', parseInt(brandId));
      }
      if (supplierId) {
        formData.append('fournisseurId', parseInt(supplierId));
      }
      if (pathForDelete.length > 0) {
        formData.append('pathForDelete', JSON.stringify(pathForDelete));
      } else {
        formData.append('pathForDelete', JSON.stringify([]));
      }
      // Add pack products
      if (packProducts.length > 0) {
        const validPacks = packProducts.filter(p => p.qte && p.prixUnitaireTTC);
        if (validPacks.length > 0) {
          formData.append('PackProducts', JSON.stringify(validPacks.map(p => ({
            qte: parseInt(p.qte, 10),
            prixUnitaireTTC: parseFloat(p.prixUnitaireTTC)
          }))));
        }
      }
      if (productImages.length > 0) {
        productImages.forEach(image => {
          if (image instanceof File) {
            formData.append('Images', image);
          }
        });
      }
      const result = await updateProduct(formData);
      if (result.success) {
        navigate('/admin/products', { state: { successMessage: 'Produit mis à jour avec succès' } });
      } else {
        throw new Error(result.message || 'Erreur lors de la mise à jour du produit');
      }
    } catch (err) {
      console.error('Error updating product:', err);
      setError(`Erreur lors de la mise à jour du produit: ${err.message || 'Erreur inconnue'}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleProductImageUpload = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setProductImages(prev => [...prev, file]);
      const reader = new FileReader();
      reader.onload = (event) => {
        setProductImagePreviews(prev => [
          ...prev,
          {
            url: event.target.result,
            isFromServer: false
          }
        ]);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = (index) => {
    const imageToRemove = productImagePreviews[index];
    if (imageToRemove.isFromServer) {
      setPathForDelete(prev => [...prev, imageToRemove.url]);
    } else {
      const fileToRemove = productImages.find((_, i) => i === productImages.length - (productImagePreviews.length - index));
      if (fileToRemove) {
        setProductImages(prev => prev.filter(file => file !== fileToRemove));
      }
    }
    setProductImagePreviews(prev => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (prixAchatTTC && tvaId && tvaRates.length > 0) {
      const selectedTva = tvaRates.find(t => t.id.toString() === tvaId.toString());
      if (selectedTva) {
        const tvaRate = selectedTva.taux / 100;
        const calculatedPrixAchatHT = (parseFloat(prixAchatTTC) / (1 + tvaRate)).toFixed(2);
        setPrixAchatHT(calculatedPrixAchatHT);
      }
    }
  }, [prixAchatTTC, tvaId, tvaRates]);

  useEffect(() => {
    if (price && tvaId && tvaRates.length > 0) {
      const selectedTva = tvaRates.find(t => t.id.toString() === tvaId.toString());
      if (selectedTva) {
        const tvaRate = selectedTva.taux / 100;
        const calculatedPrixVenteHT = (parseFloat(price) / (1 + tvaRate)).toFixed(2);
        setPrixVenteHT(calculatedPrixVenteHT);
      }
    }
  }, [price, tvaId, tvaRates]);

  const handleDeleteVariantImage = (variantIndex, imageUrl, imageIndex) => {
    const isServerImage = imageUrl.startsWith('http');
    if (isServerImage) {
      setImageToDelete({
        variantIndex,
        imageUrl,
        imageIndex
      });
      setDeleteImageModalOpen(true);
    } else {
      const updatedVariants = [...generatedVariants];
      const variant = updatedVariants[variantIndex];
      const newImageUrls = [...variant.imageUrl];
      newImageUrls.splice(imageIndex, 1);
      variant.imageUrl = newImageUrls;
      setGeneratedVariants(updatedVariants);
    }
  };

  const confirmDeleteVariantImage = async () => {
    if (!imageToDelete) return;
    try {
      setDeleteImageLoading(true);
      const { variantIndex, imageUrl, imageIndex } = imageToDelete;
      const response = await deleteVariantImage(imageUrl);
      if (response.success) {
        const updatedVariants = [...generatedVariants];
        const variant = updatedVariants[variantIndex];
        const newImageUrls = [...variant.imageUrl];
        newImageUrls.splice(imageIndex, 1);
        variant.imageUrl = newImageUrls;
        setGeneratedVariants(updatedVariants);
      } else {
        alert(`Erreur lors de la suppression: ${response.message}`);
      }
    } catch (error) {
      console.error("Error deleting variant image:", error);
      alert("Une erreur est survenue lors de la suppression de l'image");
    } finally {
      setDeleteImageLoading(false);
      setDeleteImageModalOpen(false);
      setImageToDelete(null);
    }
  };

  const handleDeleteVariantClick = (variant, index) => {
    if (variant.id && !variant.id.toString().startsWith('var-')) {
      setVariantToDelete({ variant, index });
      setDeleteVariantModalOpen(true);
    } else {
      setGeneratedVariants(generatedVariants.filter((_, i) => i !== index));
    }
  };

  const confirmDeleteVariant = async () => {
    if (!variantToDelete) return;
    try {
      setDeleteVariantLoading(true);
      const { variant, index } = variantToDelete;
      const response = await deleteVariant(variant.id);
      if (response.status === 200) {
        const updatedVariants = generatedVariants.filter((_, idx) => idx !== index);
        setGeneratedVariants(updatedVariants);
        toast.success("Variante supprimée avec succès");
        setDeleteVariantModalOpen(false);
        setVariantToDelete(null);
      } else {
        if (response.status === 417) {
          toast.error("Cette variante est déjà utilisée dans des commandes et ne peut pas être supprimée.");
        } else {
          toast.error(`Erreur lors de la suppression: ${response.message}`);
        }
      }
    } catch (error) {
      console.error("Error deleting variant:", error);
      toast.error("Une erreur est survenue lors de la suppression de la variante");
    } finally {
      setDeleteVariantLoading(false);
    }
  };

  const handleVariantImageUpload = async (e, variantIndex) => {
    const file = e.target.files[0];
    if (!file) return;
    const variant = generatedVariants[variantIndex];
    if (variant.id && !variant.id.toString().startsWith('var-')) {
      try {
        setImageUploadLoading(prev => ({ ...prev, [variantIndex]: true }));
        const response = await addProductVariantImage(variant.id, file);
        if (response.success && response.imageUrl) {
          const updatedVariants = [...generatedVariants];
          updatedVariants[variantIndex].imageUrl = [
            ...(updatedVariants[variantIndex].imageUrl || []),
            response.imageUrl
          ];
          setGeneratedVariants(updatedVariants);
          toast.success("Image ajoutée avec succès");
        } else {
          toast.error(`Erreur lors de l'ajout de l'image: ${response.message}`);
        }
      } catch (error) {
        console.error("Error uploading variant image:", error);
        toast.error("Une erreur est survenue lors de l'ajout de l'image");
      } finally {
        setImageUploadLoading(prev => ({ ...prev, [variantIndex]: false }));
      }
    } else {
      const imageUrl = URL.createObjectURL(file);
      const updatedVariants = [...generatedVariants];
      updatedVariants[variantIndex].imageUrl = [
        ...(updatedVariants[variantIndex].imageUrl || []),
        imageUrl
      ];
      setGeneratedVariants(updatedVariants);
    }
  };

  const addNewVariants = async (newSelectedVariants) => {
    if (newSelectedVariants.length === 0) return;
    const selectedValuesByAttribute = {};
    newSelectedVariants.forEach(item => {
      const attributeId = String(item.attributeId);
      const valueId = String(item.valueId);
      if (!selectedValuesByAttribute[attributeId]) {
        selectedValuesByAttribute[attributeId] = [];
      }
      selectedValuesByAttribute[attributeId].push(valueId);
    });
    const attributesWithValues = [];
    Object.entries(selectedValuesByAttribute).forEach(([attributeId, valueIds]) => {
      const attribute = variantAttributes.find(attr => String(attr.id) === attributeId);
      if (!attribute) {
        console.error(`Attribute with ID ${attributeId} not found`);
        return;
      }
      const values = [];
      for (const valueId of valueIds) {
        const value = attribute.values.find(v => String(v.id) === valueId);
        if (value) {
          values.push({
            id: valueId,
            value: value.value
          });
        }
      }
      if (values.length > 0) {
        attributesWithValues.push({
          id: attributeId,
          name: attribute.name,
          values
        });
      }
    });
    if (attributesWithValues.length === 0) {
      console.error("No attributes with selected values found");
      return;
    }
    const generateCombinations = (attributes, index = 0, current = {}, currentDisplay = [], currentOptions = []) => {
      if (index === attributes.length) {
        return [{ options: { ...current }, displayValues: [...currentDisplay], variantValues: [...currentOptions] }];
      }
      const currentAttr = attributes[index];
      const combinations = [];
      for (const val of currentAttr.values) {
        const newCurrent = { ...current };
        newCurrent[currentAttr.id] = {
          attributeId: currentAttr.id,
          attributeName: currentAttr.name,
          valueId: val.id,
          value: val.value
        };
        const newDisplay = [...currentDisplay, val.value];
        const newOptions = [...currentOptions, {
          id: 0,
          variantValueId: parseInt(val.id)
        }];
        combinations.push(...generateCombinations(attributes, index + 1, newCurrent, newDisplay, newOptions));
      }
      return combinations;
    };
    const combinations = generateCombinations(attributesWithValues);
    if (combinations.length === 0) {
      console.error("No combinations generated");
      return;
    }
    try {
      setIsSubmitting(true);
      const variantsForAPI = combinations.map((combo, index) => {
        const displayName = combo.displayValues.join(' - ');
        const variantRef = reference ? `${reference}-${generatedVariants.length + index + 1}` : `SKU-${generatedVariants.length + index + 1}`;
        return {
          reference: variantRef,
          name: displayName,
          productId: parseInt(id),
          variantValue: combo.variantValues,
          stock: 0,
          codeABarre: ''
        };
      });
      const response = await addProductVariants(id, variantsForAPI);
      if (response.success) {
        const newVariants = response.data.map((variant, index) => {
          const matchingCombo = combinations[index];
          return {
            id: variant.id,
            combination: variant.name,
            sku: variant.reference,
            stock: variant.stock || 0,
            originalStock: variant.stock || 0,
            imageUrl: variant.imageUrl || [],
            serverData: true,
            variantValues: variant.variantValue || [],
            barCode: variant.codeABarre || '', // Add barCode field from response
            options: matchingCombo.options ? Object.values(matchingCombo.options) : []
          };
        });
        setGeneratedVariants([...generatedVariants, ...newVariants]);
        setShowGeneratedVariants(true);
        toast.success("Variantes ajoutées avec succès");
      } else {
        toast.error(`Erreur lors de l'ajout des variantes: ${response.message}`);
      }
    } catch (error) {
      console.error("Error adding variants:", error);
      toast.error("Une erreur est survenue lors de l'ajout des variantes");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmitNewBrand = async (e) => {
    e.preventDefault();
    if (!newBrandName.trim()) {
      toast.error('Le nom de la marque est requis');
      return;
    }
    setIsSubmittingBrand(true);
    try {
      const createdBrand = await BrandController.createBrand({ name: newBrandName.trim() });
      setIsCreateBrandModalOpen(false);
      toast.success('Marque créée avec succès');
      setBrands([...brands, createdBrand]);
      setBrandId(createdBrand.id);
    } catch (error) {
      console.error('Error creating brand:', error);
      toast.error('Erreur lors de la création de la marque');
    } finally {
      setIsSubmittingBrand(false);
    }
  };

  const handleSubmitNewSupplier = async (e) => {
    e.preventDefault();
    if (!newSupplierName.trim()) {
      toast.error('Le nom du fournisseur est requis');
      return;
    }
    setIsSubmittingSupplier(true);
    try {
      const createdSupplier = await SupplierController.createSupplier({
        name: newSupplierName.trim(),
        email: newSupplierEmail.trim(),
        tel: newSupplierTel.trim(),
        adresse: newSupplierAddress.trim(),
        matriculeFiscal: newSupplierFiscal.trim()
      });
      setIsCreateSupplierModalOpen(false);
      toast.success('Fournisseur créé avec succès');
      setNewSupplierName('');
      setNewSupplierEmail('');
      setNewSupplierTel('');
      setNewSupplierAddress('');
      setNewSupplierFiscal('');
      try {
        setIsLoadingSuppliers(true);
        setSupplierError(null);
        const response = await SupplierController.fetchAllSuppliers();
        if (response) {
          setSuppliers(response);
          setSupplierId(createdSupplier.id);
        } else {
          setSuppliers([]);
        }
      } catch (error) {
        console.error('Error fetching suppliers after creation:', error);
        setSupplierError('Impossible de mettre à jour la liste des fournisseurs');
        setSuppliers(prev => [...prev, createdSupplier]);
        setSupplierId(createdSupplier.id);
      } finally {
        setIsLoadingSuppliers(false);
      }
    } catch (error) {
      console.error('Error creating supplier:', error);
      toast.error('Erreur lors de la création du fournisseur');
    } finally {
      setIsSubmittingSupplier(false);
    }
  };


  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <div className="py-6 px-4 sm:px-6 lg:px-8">
      <ProductHeader 
        title="Modifier le produit" 
        subtitle="Modifiez les informations du produit existant."
      />

      <ErrorBanner error={error} />

      <div className="bg-white shadow rounded-lg overflow-hidden">
        

        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="p-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <ProductInfoSection
              productName={productName}
              setProductName={setProductName}
              productDesc={productDesc}
              setProductDesc={setProductDesc}
              reference={reference}
              setReference={setReference}
              barcode={barcode}
              setBarcode={setBarcode}
            />

            <PricingSection
              prixAchatHT={prixAchatHT}
              prixAchatTTC={prixAchatTTC}
              setPrixAchatTTC={setPrixAchatTTC}
              prixVenteHT={prixVenteHT}
              price={price}
              setPrice={setPrice}
            />

            {/* Promo toggle and promo input for edit page */}
            <div className="sm:col-span-3">
              <div className="relative flex items-start bg-gray-50 p-4 rounded-md border border-gray-200">
                <div className="flex items-center h-5">
                  <input
                    id="enPromo"
                    name="enPromo"
                    type="checkbox"
                    checked={enPromo}
                    onChange={(e) => setEnPromo(e.target.checked)}
                    className="focus:ring-[#174540] h-5 w-5 text-[#174540] border-gray-300 rounded transition-colors"
                  />
                </div>
                <div className="ml-3 text-sm w-full">
                  <label htmlFor="enPromo" className="font-medium text-gray-700">Mettre en promotion</label>
                  <p className="text-gray-500">Activez pour appliquer un prix promotionnel.</p>

                  <div className="mt-3">
                    <input
                      type="number"
                      name="prixVentePromo"
                      id="prixVentePromo"
                      min="0"
                      step="0.01"
                      value={prixVentePromo}
                      onChange={(e) => setPrixVentePromo(e.target.value)}
                      placeholder="Prix promo (ex: 9.99)"
                      disabled={!enPromo}
                      className={`mt-1 block w-full pl-3 py-2.5 sm:text-sm border border-gray-300 rounded-md transition-colors ${enPromo ? '' : 'bg-gray-100'}`}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Free delivery toggle and quantity input for edit page */}
            <div className="sm:col-span-3">
              <div className="relative flex items-start bg-gray-50 p-4 rounded-md border border-gray-200">
                <div className="flex items-center h-5">
                  <input
                    id="livraisonGratuit"
                    name="livraisonGratuit"
                    type="checkbox"
                    checked={livraisonGratuit}
                    onChange={(e) => setLivraisonGratuit(e.target.checked)}
                    className="focus:ring-[#174540] h-5 w-5 text-[#174540] border-gray-300 rounded transition-colors"
                  />
                </div>
                <div className="ml-3 text-sm w-full">
                  <label htmlFor="livraisonGratuit" className="font-medium text-gray-700">Livraison gratuite</label>
                  <p className="text-gray-500">Activez et indiquez le nombre de produits bénéficiant de la livraison gratuite.</p>

                  <div className="mt-3">
                    <input
                      type="number"
                      name="livraisonGratuitQuantite"
                      id="livraisonGratuitQuantite"
                      min="0"
                      step="1"
                      value={livraisonGratuitQuantite}
                      onChange={(e) => setLivraisonGratuitQuantite(e.target.value)}
                      placeholder="Nombre de produits (ex: 2)"
                      disabled={!livraisonGratuit}
                      className={`mt-1 block w-full pl-3 py-2.5 sm:text-sm border border-gray-300 rounded-md transition-colors ${livraisonGratuit ? '' : 'bg-gray-100'}`}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Stock required toggle */}
            <div className="sm:col-span-3">
              <div className="relative flex items-start bg-gray-50 p-4 rounded-md border border-gray-200">
                <div className="flex items-center h-5">
                  <input
                    id="stockRequis"
                    name="stockRequis"
                    type="checkbox"
                    checked={stockRequis}
                    onChange={(e) => setStockRequis(e.target.checked)}
                    className="focus:ring-[#174540] h-5 w-5 text-[#174540] border-gray-300 rounded transition-colors"
                  />
                </div>
                <div className="ml-3 text-sm w-full">
                  <label htmlFor="stockRequis" className="font-medium text-gray-700">Stock requis</label>
                  <p className="text-gray-500">
                    {stockRequis
                      ? 'Le client ne peut commander que si le produit est en stock.'
                      : 'Le client peut commander même sans stock, et le stock n’est pas affiché sur la boutique.'}
                  </p>
                </div>
              </div>
            </div>

            <SupplierDropdown
              suppliers={suppliers}
              supplierId={supplierId}
              isSupplierDropdownOpen={isSupplierDropdownOpen}
              setIsSupplierDropdownOpen={setIsSupplierDropdownOpen}
              supplierSearchTerm={supplierSearchTerm}
              setSupplierSearchTerm={setSupplierSearchTerm}
              isLoadingSuppliers={isLoadingSuppliers}
              supplierError={supplierError}
              filteredSuppliers={filteredSuppliers}
              handleOpenCreateSupplierModal={() => {
                setIsSupplierDropdownOpen(false);
                setIsCreateSupplierModalOpen(true);
              }}
              setDropdownPosition={setDropdownPosition}
              setSupplierId={setSupplierId}
            />

            <BrandDropdown
              brands={brands}
              brandId={brandId}
              isBrandDropdownOpen={isBrandDropdownOpen}
              setIsBrandDropdownOpen={setIsBrandDropdownOpen}
              brandSearchTerm={brandSearchTerm}
              setBrandSearchTerm={setBrandSearchTerm}
              isLoadingBrands={isLoadingBrands}
              brandError={brandError}
              filteredBrands={filteredBrands}
              handleOpenCreateBrandModal={() => {
                setIsBrandDropdownOpen(false);
                setIsCreateBrandModalOpen(true);
              }}
              setDropdownPosition={setDropdownPosition}
              setBrandId={setBrandId}
            />

            <TVADropdown
              tvaRates={tvaRates}
              tvaId={tvaId}
              isTvaDropdownOpen={isTvaDropdownOpen}
              setIsTvaDropdownOpen={setIsTvaDropdownOpen}
              tvaSearchTerm={tvaSearchTerm}
              setTvaSearchTerm={setTvaSearchTerm}
              filteredTvaRates={filteredTvaRates}
              dropdownPosition={dropdownPosition}
              setTvaId={setTvaId}
              setDropdownPosition={setDropdownPosition}
            />

            <ProductImagesSection
              productImagePreviews={productImagePreviews}
              handleRemoveImage={handleRemoveImage}
              handleProductImageUpload={handleProductImageUpload}
            />

            <VariantToggleSection
              enableVariants={enableVariants}
              setEnableVariants={setEnableVariants}
            />

            <VariantConfigurationSection
              enableVariants={enableVariants}
              setIsVariantModalOpen={setIsVariantModalOpen}
              showGeneratedVariants={showGeneratedVariants}
              generatedVariants={generatedVariants}
              handleDeleteVariantImage={handleDeleteVariantImage}
              handleVariantImageUpload={handleVariantImageUpload}
              handleDeleteVariantClick={handleDeleteVariantClick}
              imageUploadLoading={imageUploadLoading}
              setGeneratedVariants={setGeneratedVariants}
            />

            {/* PackProductSection component */}
            <PackProductSection
              packs={packProducts}
              setPacks={setPackProducts}
            />
          </div>

          <FormActionsFooter isSubmitting={isSubmitting} />
        </form>
      </div>

      <ConfirmationModals
        deleteImageModalOpen={deleteImageModalOpen}
        setDeleteImageModalOpen={setDeleteImageModalOpen}
        confirmDeleteVariantImage={confirmDeleteVariantImage}
        deleteVariantModalOpen={deleteVariantModalOpen}
        setDeleteVariantModalOpen={setDeleteVariantModalOpen}
        confirmDeleteVariant={confirmDeleteVariant}
      />

      <CreationModals
        isCreateSupplierModalOpen={isCreateSupplierModalOpen}
        setIsCreateSupplierModalOpen={setIsCreateSupplierModalOpen}
        handleSubmitNewSupplier={handleSubmitNewSupplier}
        newSupplierName={newSupplierName}
        setNewSupplierName={setNewSupplierName}
        newSupplierEmail={newSupplierEmail}
        setNewSupplierEmail={setNewSupplierEmail}
        newSupplierTel={newSupplierTel}
        setNewSupplierTel={setNewSupplierTel}
        newSupplierAddress={newSupplierAddress}
        setNewSupplierAddress={setNewSupplierAddress}
        newSupplierFiscal={newSupplierFiscal}
        setNewSupplierFiscal={setNewSupplierFiscal}
        isSubmittingSupplier={isSubmittingSupplier}
        isCreateBrandModalOpen={isCreateBrandModalOpen}
        setIsCreateBrandModalOpen={setIsCreateBrandModalOpen}
        handleSubmitNewBrand={handleSubmitNewBrand}
        newBrandName={newBrandName}
        setNewBrandName={setNewBrandName}
        isSubmittingBrand={isSubmittingBrand}
      />

      {/* EditProductVariantModal */}
      <EditProductVariantModal
        isOpen={isVariantModalOpen}
        onClose={() => setIsVariantModalOpen(false)}
        variantAttributes={variantAttributes}
        toggleVariantValue={toggleVariantValue}
        addNewVariants={addNewVariants}
      />

    </div>
  );
};

export default EditProductPage;